import React from 'react'

import Notice, { NoticeProps } from './Notice'

function NoticeList({ notices }: { notices: NoticeProps[] }) {
  return (
    <>
      {notices && notices.length ? (
        notices.map((notice) => <Notice {...notice} key={notice.id} />)
      ) : (
        <div className="text-center">
          <h4>No Active Notices</h4>
        </div>
      )}
    </>
  )
}

export default NoticeList
